import React from "react";
import { Preloader, Oval } from 'react-preloader-icon';
import "./preLoader.scss"

export const PreLoader = ()=>{
    return(
        <div className="pre-loader">
 <Preloader
    use={Oval}
    size={60}
    strokeWidth={6}
    strokeColor="#007bff"
    duration={2000}
  />

        </div>
    )
}